import { render } from "./PrescriberTwoFactorEnableAuth.vue?vue&type=template&id=8a746424&scoped=true"
import script from "./PrescriberTwoFactorEnableAuth.vue?vue&type=script&lang=js"
export * from "./PrescriberTwoFactorEnableAuth.vue?vue&type=script&lang=js"

import "./PrescriberTwoFactorEnableAuth.vue?vue&type=style&index=0&id=8a746424&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a746424"]])

export default __exports__